
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class VContextList extends Vue {
    @Prop({ type: Array, default: () => [] })
    public items!: unknown;

    @Prop({ type: Function, default: (value: unknown) => value })
    public layout!: (value: unknown) => unknown;

    @Prop({ type: Function, default: (value: unknown) => value })
    public reduce!: (value: unknown) => unknown;

    public visible = false;

    select(value: unknown) {
        this.$emit('selected', this.reduce(value));
    }

    public show(x: number, y: number) {
        this.visible = true;
        this.setElementPosition(x, y);
    }

    public hide() {
        this.visible = false;
    }

    public setElementPosition(x: number, y: number) {
        const elementHeight = this.$el.clientHeight;
        const elementWidth = this.$el.clientWidth;

        const maxPositionX = window.innerWidth - elementWidth;
        const maxPositionY = window.innerHeight - elementHeight;

        y = y > maxPositionY ? maxPositionY : y;
        x = x > maxPositionX ? maxPositionX : x;

        (this.$el as HTMLElement).style.top = `${y}px`;
        (this.$el as HTMLElement).style.left = `${x}px`;
    }

    mounted() {
        window.addEventListener('wheel', this.hide);
        this.$once('hook:beforeDestroy', () => window.removeEventListener('wheel', this.hide));
    }
}
